import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: theme.spacing(15, 'auto'),
  },
  mobileScreenShotsContainer: {
    display: 'flex',
    overflowX: 'scroll',
    width: '100%',
    paddingLeft: theme.spacing(19),
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  screenShotLottie: {
    height: '390px',
    aspectRatio: '180/390',
  },

  [theme.breakpoints.down('sm')]: {
    mobileScreenShotsContainer: {
      paddingLeft: theme.spacing(2),
      '& > div': {
        '&:not(:last-child)': {
          marginRight: theme.spacing(5),
        },
      },
    },
    mobileScreenShotLottie: {
      width: '150px',
      aspectRatio: '120/260',
    },
  },
}))
